module.exports = __webpack_public_path__ + "static/img/arrow-left.png";